import React, { useEffect, useState } from 'react';
import Modal from "react-modal";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Label, FormGroup, Col, Form, Input } from 'reactstrap';
import { FaSistrix } from "react-icons/fa";
import { getCustomStyles } from "../share/ModalStyle";
// import { AiOutlineClose } from "react-icons/ai";
import { CgClose } from "react-icons/cg";
import '../share/form.css'
import Swal from "sweetalert2";


export function ConsiderRegisterDetailComponent() {
    const myCustomStyles = getCustomStyles()
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    // รับค่า id มาจาก useparams (มาจากหน้าตาราง)
    const id = searchParams.get("req")
    // const { id } = useParams();

    // state get ข้อมูลมาจาก database โดยส่ง id เข้าไป
    const [data, setData] = useState([]);
    console.log(data)

    //  state รับข้อมูลเพื่อที่จะ gen username ให้กับ user พร้อม message เมื่อปฎิเสธคำขอลงทะเบียน
    const [message, setMessage] = useState("");
    const [getUsername, setGetUsername] = useState("");
    console.log("getUsername", getUsername);
    // toglle modal เมื่อปฎิเสธคำขอลงทะเบียน
    const [modal, setModal] = useState(false);
    const modalToggle = () => setModal(!modal);

    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }
    function onClickUrl(url) {
        return () => openInNewTab(url)
    }

    // function gen username โดยเอาข้อมูลที่ส่งออกมาจาก database มาทำเงื่อนไขการ gen ตาม type ของ register id นั้นๆ จากนั้นเก็บไว้ที่ state เพื่อเตรียมส่งกลับไปที่ database  
    const GenUsername = async (data) => {
        console.log("data", data);
        const username = await data.map((item) => {
            if (item.typeName === "นิติบุคคล") {
                let type = item.registerType.find((value) => value === "ผู้ประกอบกิจการ")
                if (type) {
                    setGetUsername(item.companyNo)
                    return true
                } else {
                    let isTesting = item.registerType.find(val => val === "ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน");
                    let isEstimate = item.registerType.find(val => val === "ศูนย์ประเมินความรู้ความสามารถตามมาตรา 26/4 (2)");
                    if (isTesting) {
                        let licenseNo = item?.licenseNo ?? "";
                        let customerNo = item?.customerNo ?? "";
                        setGetUsername(`${licenseNo}_${customerNo}`)
                        return true;
                    }

                    if (isEstimate) {
                        let certificate26No = item?.certificate26No ?? "";
                        let customerNo = item?.customerNo ?? "";
                        setGetUsername(`${certificate26No}_${customerNo}`)
                        return true;
                    }

                    setGetUsername(item.customerNo)
                    return true
                }
            } else {
                setGetUsername(item.customerNo)
                return true
            }
        })
        return username
    };

    async function onSubmit(e) {
        let preMessage;
        if (e.target.name == "reject") {
            preMessage = "ยืนยันการปฎิเสธการลงทะเบียนหรือไม่ ?"
        } else if (e.target.name == "approve") {
            preMessage = "ยืนยันการอนุมัติการลงทะเบียนหรือไม่ ?"
        }
        Swal.fire({
            icon: "info",
            // title: message,
            text: preMessage,
            confirmButtonColor: "#0A66C2",
            confirmButtonText: "ตกลง",
            showCancelButton: true,
            cancelButtonText: "ยกเลิก",
            cancelButtonColor: "#ff0000",
        }).then(async (result) => {
            if (result.isConfirmed) {
                // console.log("fdsfdsfdsf")
                let postData = new FormData();
                postData.append("status", e.target.name);
                postData.append("registerId", id);
                postData.append("message", message);
                postData.append("username", getUsername);

                try {
                    let res = await fetch("/api/Admin/approveOrRejectRegister", {
                        method: "POST",
                        body: postData
                    });
                    let resJson = await res.json();

                    if (resJson.status === 1) {
                        Swal.fire({
                            icon: "success",
                            title: "อนุมัติการลงทะเบียนสำเร็จ",
                            text: "",
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate("/request/")
                            }
                        });
                    } else if (resJson.status === 2) {
                        Swal.fire({
                            title: `${resJson.message}`,
                            text: "",
                            icon: 'success',
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate("/request/")
                            }
                        });
                    } else {
                        Swal.fire({
                            title: `${resJson.message}`,
                            text: "",
                            icon: 'warning',
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate("/request/")
                            }
                        });
                    }
                } catch (e) {
                    console.log(e)
                }
            }
        })

        // actions.resetForm();
    }




    useEffect(() => {
        GetDetailRegister(id)

    }, [id])

    //ดึงรายละเอียด register id มาแสดง 
    async function GetDetailRegister(id) {
        // console.log(typeof(id));
        let postData = new FormData();
        postData.append("registerId", id);
        try {
            let res = await fetch("/api/Admin/getDetailRegister", {
                method: "POST",
                body: postData
            });
            const dataDetail = await res.json()
            setData(dataDetail.dataenum);
            // console.log(dataDetail.dataenum);
            GenUsername(dataDetail.dataenum);
        } catch (err) {
            console.log("err =>" + err);
        }
    }


    return (
        <Container className="mb-5 d-flex justify-content-center">
            {data.map((item, i) => (
                <div
                    key={i}
                    className="p-5 mb-4 form-border"
                >
                    {/* แสดงข้อมูลพวกประเภทการสมัคร การลงทะเบียน เลข 13 หลัก และ หน่วยงานที่ยื่นสมัคร  */}
                    <FormGroup>
                        <Label className="">ประเภทผู้สมัคร :</Label>
                        <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">{item.typeName}</p>
                    </FormGroup>

                    <FormGroup>
                        <Label className="">ประเภทการสมัคร :</Label>
                        <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                            {item.registerType.map((type, index) => (

                                <span key={index} className="customer-type mx-2 py-1 text-center">
                                    {type}
                                </span>

                            ))}
                        </p>
                    </FormGroup>
                    {/* แสดงชื่อ สกุ่ล(กรณีบุคคลธรรมดา) และ ชื่อสถานประกอบการ (กรณีนิติบุคคล) */}
                    {item.titleName != null ? (
                        <FormGroup>
                            <Label>ชื่อ:</Label>
                            <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">{item.fullName}</p>
                        </FormGroup>
                    ) : (
                        <FormGroup>
                            <Label>ชื่อสถานประกอบการ :</Label>
                            <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">{item.fullName ? item.fullName : "-"}</p>
                        </FormGroup>
                    )
                    }
                    {item.certificate26No ? (
                        <>
                            <FormGroup>
                                <Label>ชื่อศูนย์ประเมินความรู้ความสามารถตามมาตรา 26/4 (2) :</Label>
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">{item.certificate26Name}</p>
                            </FormGroup>
                            <FormGroup>
                                <Label>เลขที่หนังสือรับรองการเป็นศูนย์ประเมินความรู้ความสามารถตามมาตรา 26/4 (2) :</Label>
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">{item.certificate26No}</p>
                            </FormGroup>

                        </>

                    ) : null}

                    <FormGroup>
                        <Label>เลขทะเบียนนิติบุคคล/เลขทะเบียนพาณิชย์/เลขประจำตัวประชาชน (13 หลัก) :</Label>
                        <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">{item.customerNo}</p>
                    </FormGroup>

                    <FormGroup>
                        <Label>หน่วยงานกรมพัฒนาฝีมือแรงงานที่ต้องการติดต่อ :</Label>
                        <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">{item.deptName}</p>
                    </FormGroup>




                    {/* แสดงประเภทอุตสาหกรรม */}
                    {item.industrialName != null ? (
                        <>
                            <Label className="mb-3">ประเภทอุตสาหกรรม</Label>

                            <FormGroup className="mx-4">
                                <Label>หมวดย่อย (2 หลัก) :</Label>
                                <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">{item.industrialName}</p>
                            </FormGroup>
                            <FormGroup className="mx-4">
                                <Label>กิจกรรม (5 หลัก) :</Label>
                                <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">{item.industryName}</p>
                            </FormGroup>
                        </>
                    ) : null}

                    {/* แสดงจำนวนวันที่มีลูกจ้างเกิน 100 คน */}
                    {item.employDateStr != null ? (

                        <FormGroup>
                            <Label>วันที่มีลูกจ้างมากกว่า 100 คน :</Label>
                            <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">{item.employDateStr}</p>
                        </FormGroup>

                    ) : null}

                    {/* แสดงประกอบกิจการประเภท */}
                    {item.businessType != null ? (
                        <FormGroup>
                            <Label>ประกอบกิจการประเภท</Label>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">{item.businessType}</p>
                        </FormGroup>

                    ) : null}
                    <FormGroup>
                        <Label>เลขที่ใบอนุญาตเป็นผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน</Label>
                        <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{item.licenseNo ? item.licenseNo : "-"}</p>
                    </FormGroup>
                    {item.certificateRegisterDataes ? (
                        <div className="cus-type mx-2">
                            <div className="my-3 px-3">
                                <h4 className="text-center input-color">ข้อมูลศูนย์ทดสอบมาตรฐานฝีมือแรงงาน</h4>
                                <Label className="">ชื่อศูนย์ทดสอบมาตรฐานฝีมือแรงงาน : <span className="input-color">{item.certificateRegisterDataes.centerName}</span></Label>
                                <Label className="mt-2">ชื่อหน่วยงานกรมพัฒนาฝีมือแรงงานในพื้นที่ที่ศูนย์ฝึกอบรมฝีมือแรงงาน: </Label>
                                <Input
                                    disabled={true}
                                    className="rounded-pill text-center input-color"
                                    value={item.certificateRegisterDataes.site}
                                />
                                <Label className="mt-2 w-100 mt-2">วันที่เริ่มดำเนินงาน : <span className="input-color">{item.certificateRegisterDataes.dateCreate}</span></Label>
                                <Label className="mt-2 w-100 mt-2">สถานะการดำเนินงาน : <span className="input-color">{item.certificateRegisterDataes.workOn === "1" ? "ยังดำเนินการอยู่" : ""}</span></Label>

                                <div className="mt-2">
                                    <Label>ที่อยู่ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน:
                                        <span className="input-color mx-1">{item.certificateRegisterDataes?.address ?? "-"}</span>
                                        เบอร์โทร : <span className="input-color mx-1">{item.certificateRegisterDataes?.tel ?? "-"}</span>
                                        อีเมล : <span className="input-color mx-1">{item.certificateRegisterDataes?.email ?? "-"}</span>
                                    </Label>
                                </div>
                            </div>
                        </div>
                    ) : null}

                    {/* แสดงชื่อผู้ประสานงาน และ เบอร์โทรติดต่อ */}
                    {item.contactName != null ? (
                        <div className="d-flex justify-content-between align-items-center">

                            <FormGroup className="w-50 mx-2">
                                <Label>ชื่อ-นามสกุลผู้ประสานงาน</Label>
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">{item.contactName}</p>
                            </FormGroup>

                            <FormGroup className="w-50 mx-2">
                                <Label>หมายเลขโทรศัพท์ผู้ประสานงาน</Label>
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">{item.contactPhone}</p>
                            </FormGroup>

                        </div>

                    ) : null}

                    {/* แสดงที่อยู่ (กรณีนิติบุคคล) และ ที่อยู่ตามทะเบียนบ้าน และที่อยู่ปัจจุบัน (บุคคลธรรมดา) */}
                    {item.cAddress.length !== 0 ? (
                        <>
                            <Label
                                for="address">ที่อยู่ตามทะเบียนบ้าน:
                            </Label>
                            <div className="px-4 pt-4">
                                {item.address.map((address, index) => (
                                    <React.Fragment key={index}>
                                        <FormGroup row>
                                            <Label
                                                for="addNo"
                                                sm={2}
                                            >
                                                เลขที่
                                            </Label>
                                            <Col sm={4}>
                                                <p
                                                    className="customer-type border border-1 py-1 rounded-pill w-100 text-center" >
                                                    {address.addNo}
                                                </p>
                                            </Col>

                                            <Label
                                                for="moo"
                                                sm={2}
                                            >
                                                หมู่ที่
                                            </Label>
                                            <Col sm={4}>
                                                {address.addMoo != null ? (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        {address.addMoo}
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        -
                                                    </p>
                                                )}
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="soi"
                                                sm={2}
                                            >
                                                ซอย
                                            </Label>
                                            <Col sm={4}>
                                                {address.addSoi != null ? (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        {address.addSoi}
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        -
                                                    </p>
                                                )}
                                            </Col>

                                            <Label
                                                for="street"
                                                sm={2}
                                            >
                                                ถนน
                                            </Label>
                                            <Col sm={4}>
                                                {address.addStreet != null ? (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        {address.addStreet}
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        -
                                                    </p>
                                                )}
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="tumbon"
                                                sm={2}
                                            >
                                                ตำบล
                                            </Label>
                                            <Col sm={4}>
                                                {address.addTumbon != null ? (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        {address.addTumbon}
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        -
                                                    </p>
                                                )}
                                            </Col>

                                            <Label
                                                for="amphur"
                                                sm={2}
                                            >
                                                อำเภอ
                                            </Label>
                                            <Col sm={4}>
                                                {address.addAmphur != null ? (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        {address.addAmphur}
                                                    </p>
                                                ) : (
                                                    <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        -
                                                    </p>
                                                )}
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="tumbon"
                                                sm={2}
                                            >
                                                จังหวัด
                                            </Label>
                                            <Col sm={4}>
                                                {address.addProvince != null ? (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        {address.addProvince}
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        -
                                                    </p>
                                                )}
                                            </Col>

                                            <Label
                                                for="amphur"
                                                sm={2}
                                            >
                                                รหัสไปรษณีย์
                                            </Label>
                                            <Col sm={4}>
                                                {address.addPostCode != null ? (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        {address.addPostCode}
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        -
                                                    </p>
                                                )}
                                            </Col>
                                        </FormGroup>
                                    </React.Fragment>
                                ))}
                            </div>


                            <Label
                                for="cAddress">
                                ที่อยู่ปัจจุบัน(ที่ติดต่อได้):
                            </Label>
                            <div className="px-4 pt-4">
                                {item.cAddress.map((address, index) => (
                                    <React.Fragment key={index}>
                                        <FormGroup row>
                                            <Label
                                                for="addNo"
                                                sm={2}
                                            >
                                                เลขที่
                                            </Label>
                                            <Col sm={4}>
                                                <p
                                                    className="customer-type border border-1 py-1 rounded-pill w-100 text-center" >
                                                    {address.addNo}
                                                </p>
                                            </Col>

                                            <Label
                                                for="moo"
                                                sm={2}
                                            >
                                                หมู่ที่
                                            </Label>
                                            <Col sm={4}>
                                                {address.addMoo != null ? (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        {address.addMoo}
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        -
                                                    </p>
                                                )}
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="soi"
                                                sm={2}
                                            >
                                                ซอย
                                            </Label>
                                            <Col sm={4}>
                                                {address.addSoi != null ? (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        {address.addSoi}
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        -
                                                    </p>
                                                )}
                                            </Col>

                                            <Label
                                                for="street"
                                                sm={2}
                                            >
                                                ถนน
                                            </Label>
                                            <Col sm={4}>
                                                {address.addStreet != null ? (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        {address.addStreet}
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        -
                                                    </p>
                                                )}
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="tumbon"
                                                sm={2}
                                            >
                                                ตำบล
                                            </Label>
                                            <Col sm={4}>
                                                {address.addTumbon != null ? (
                                                    <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">{address.addTumbon}</p>
                                                ) : (
                                                    <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">-</p>
                                                )}
                                            </Col>

                                            <Label
                                                for="amphur"
                                                sm={2}
                                            >
                                                อำเภอ
                                            </Label>
                                            <Col sm={4}>
                                                {address.addAmphur != null ? (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        {address.addAmphur}
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        -
                                                    </p>
                                                )}
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="tumbon"
                                                sm={2}
                                            >
                                                จังหวัด
                                            </Label>
                                            <Col sm={4}>
                                                {address.addProvince != null ? (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        {address.addProvince}
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        -
                                                    </p>
                                                )}
                                            </Col>

                                            <Label
                                                for="amphur"
                                                sm={2}
                                            >
                                                รหัสไปรษณีย์
                                            </Label>
                                            <Col sm={4}>
                                                {address.addPostCode != null ? (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        {address.addPostCode}
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        -
                                                    </p>
                                                )}
                                            </Col>
                                        </FormGroup>
                                    </React.Fragment>
                                ))}
                            </div>

                        </>
                    ) : (
                        // แสดงที่อยู่ กรณีเป็นนิติบุคคล
                        <>
                            <Label
                                for="address">ที่อยู่
                            </Label>

                            <div className="px-4 pt-4">
                                {item.address.map((address, index) => (
                                    <React.Fragment key={index}>
                                        <FormGroup row>
                                            <Label
                                                for="addNo"
                                                sm={2}
                                            >
                                                เลขที่
                                            </Label>
                                            <Col sm={4}>
                                                <p
                                                    className="customer-type border border-1 py-1 rounded-pill w-100 text-center" >
                                                    {address.addNo}
                                                </p>
                                            </Col>

                                            <Label
                                                for="moo"
                                                sm={2}
                                            >
                                                หมู่ที่
                                            </Label>
                                            <Col sm={4}>
                                                {address.addMoo != null ? (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        {address.addMoo}
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        -
                                                    </p>
                                                )}
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="soi"
                                                sm={2}
                                            >
                                                ซอย
                                            </Label>
                                            <Col sm={4}>
                                                {address.addSoi != null ? (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        {address.addSoi}
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        -
                                                    </p>
                                                )}
                                            </Col>

                                            <Label
                                                for="street"
                                                sm={2}
                                            >
                                                ถนน
                                            </Label>
                                            <Col sm={4}>
                                                {address.addStreet != null ? (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        {address.addStreet}
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        -
                                                    </p>
                                                )}
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="tumbon"
                                                sm={2}
                                            >
                                                ตำบล
                                            </Label>
                                            <Col sm={4}>
                                                {address.addTumbon != null ? (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        {address.addTumbon}
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        -
                                                    </p>
                                                )}
                                            </Col>

                                            <Label
                                                for="amphur"
                                                sm={2}
                                            >
                                                อำเภอ
                                            </Label>
                                            <Col sm={4}>
                                                {address.addAmphur != null ? (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        {address.addAmphur}
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        -
                                                    </p>
                                                )}
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="tumbon"
                                                sm={2}
                                            >
                                                จังหวัด
                                            </Label>
                                            <Col sm={4}>
                                                {address.addProvince != null ? (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        {address.addProvince}
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        -
                                                    </p>
                                                )}
                                            </Col>

                                            <Label
                                                for="amphur"
                                                sm={2}
                                            >
                                                รหัสไปรษณีย์
                                            </Label>
                                            <Col sm={4}>
                                                {address.addPostCode != null ? (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        {address.addPostCode}
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                                        -
                                                    </p>
                                                )}
                                            </Col>
                                        </FormGroup>
                                    </React.Fragment>
                                ))}
                            </div>
                        </>
                    )}
                    {/* แสดงอีเมล */}
                    <FormGroup>
                        <Label>อีเมล:</Label>
                        <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">{item.email}</p>
                    </FormGroup>
                    {/* แสดงเบอร์โทรศัพท์ */}
                    <FormGroup>
                        <Label>เบอร์โทรศัพท์ :</Label>
                        <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">{item.phone ? item.phone : "-"}</p>
                    </FormGroup>
                    {/* แสดงโทรสาร  */}
                    {item.fax != null ? (
                        <FormGroup>
                            <Label>โทรสาร:</Label>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">{item.fax}</p>
                        </FormGroup>
                    ) : null}

                    {item.authRegister != null && item.authRegister.length > 0 ? (
                        <div className="mt-4">
                            <Label
                                for="address">ข้อมูลผู้มีอำนาจ
                            </Label>

                            {item.authRegister.map((auth, index) => {
                                console.log("auth", auth);
                                return (
                                    <div index={index}>

                                        <div className="px-4 pt-3">
                                            <FormGroup row>
                                                <Label
                                                    for="customer_no">
                                                    ชื่อ - สกุล ผู้มีอำนาจคนที่ {index + 1} :
                                                </Label>
                                                <div className="d-flex justify-content-start px-6">
                                                    <div className="flex-grow-1">
                                                        <Input
                                                            className={"rounded-pill rounded-end text-center input-color"
                                                            }
                                                            type="text"
                                                            name="authTitleId"
                                                            id="authTitleId"
                                                            disabled
                                                            value={auth?.authTitleId}

                                                        />
                                                    </div>

                                                    <div className="w-75">
                                                        <Input
                                                            className={"rounded-pill rounded-start text-center input-color"}
                                                            type="text"
                                                            name="authFullName"
                                                            id="authFullName"
                                                            placeholder="ชื่อ-สกุล"
                                                            disabled
                                                            value={auth?.authFullName ?? "-"}


                                                        />
                                                    </div>
                                                </div>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label
                                                    for="customer_no">
                                                    เลขบัตรประจำตัวประชาชน :
                                                </Label>
                                                <Input
                                                    className={"rounded-pill  text-center input-color px-6"}
                                                    type="text"
                                                    name="authPersonalId"
                                                    id="authPersonalId"
                                                    disabled
                                                    value={auth?.authPersonalId ?? "-"}


                                                />
                                            </FormGroup>

                                        </div>

                                        <Label
                                            for="customer_no" className="px-4">
                                            ที่อยู่
                                        </Label>

                                        <div className="px-5 mt-2">
                                            <FormGroup row>
                                                <Label
                                                    for="addNo"
                                                    sm={2}
                                                >
                                                    เลขที่

                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="authAddressNo"
                                                        name="authAddressNo"
                                                        type="text"
                                                        className={"rounded-pill text-center input-color"}
                                                        disabled
                                                        value={auth?.authAddressNo ?? "-"}
                                                    />
                                                </Col>

                                                <Label
                                                    for="moo"
                                                    sm={2}
                                                >
                                                    หมู่ที่
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="authAddressMoo"
                                                        name="authAddressMoo"
                                                        type="text"
                                                        className="rounded-pill text-center input-color"
                                                        disabled
                                                        value={auth?.authAddressMoo ?? "-"}

                                                    />
                                                </Col>
                                            </FormGroup>

                                            <FormGroup row>
                                                <Label
                                                    for="soi"
                                                    sm={2}
                                                >
                                                    ซอย
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="authAddressSoi"
                                                        name="authAddressSoi"
                                                        type="text"
                                                        className="rounded-pill text-center input-color"
                                                        disabled
                                                        value={auth?.authAddressSoi ?? "-"}

                                                    />
                                                </Col>

                                                <Label
                                                    for="street"
                                                    sm={2}
                                                >
                                                    ถนน
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="authAddressStreet"
                                                        name="authAddressStreet"
                                                        type="text"
                                                        className="rounded-pill text-center input-color"
                                                        disabled
                                                        value={auth?.authAddressStreet ?? "-"}

                                                    />
                                                </Col>
                                            </FormGroup>

                                            <FormGroup row>
                                                <Label
                                                    for="addProvince"
                                                    sm={2}
                                                >
                                                    จังหวัด

                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="authAddressProvince"
                                                        name="authAddressProvince"
                                                        type="text"
                                                        className="rounded-pill text-center input-color"
                                                        disabled
                                                        value={auth?.authAddressProvince ?? "-"}
                                                    />

                                                </Col>

                                                <Label
                                                    for="district_id"
                                                    sm={2}
                                                >
                                                    อำเภอ/เขต

                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="authAddressDistrict"
                                                        name="authAddressDistrict"
                                                        type="text"
                                                        className="rounded-pill text-center input-color"
                                                        disabled
                                                        value={auth?.authAddressDistrict ?? "-"}
                                                    />

                                                </Col>
                                            </FormGroup>

                                            <FormGroup row>
                                                <Label
                                                    for="addTumbon"
                                                    sm={2}
                                                >
                                                    ตำบล/แขวง

                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="authAddressTumbon"
                                                        name="authAddressTumbon"
                                                        type="text"
                                                        className="rounded-pill text-center input-color"
                                                        disabled
                                                        value={auth?.authAddressTumbon ?? "-"}

                                                    />
                                                </Col>

                                                <Label
                                                    for="postcode"
                                                    sm={2}
                                                >
                                                    รหัสไปรษณีย์
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        maxLength={5}
                                                        id="authAddressPostCode"
                                                        name="authAddressPostCode"
                                                        type="text"
                                                        className="rounded-pill text-center input-color"
                                                        disabled
                                                        value={auth?.authAddressPostCode ?? "-"}
                                                    />
                                                </Col>
                                            </FormGroup>
                                        </div>
                                    </div>
                                )
                            })}

                        </div>

                    ) : null}














                    {/* แสดงบัญชีผู้ใช้งาน เลข10 หลัก วัดจากกรณีนิติบุคคล ถ้าเป็นผู้ประกอบกิจการ จะใช้เลข 10 หลักนะ แต่ถ้าไม่ ก็ใช้เลข 13 หลัก   */}
                    {item.companyNo !== null ? (
                        <FormGroup className="mt-3">
                            <Label
                                for="note"
                                className="text-left">
                                บัญชีผู้ใช้งาน:
                            </Label>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">{getUsername}</p>
                        </FormGroup>
                    ) : (
                        <FormGroup className="mt-3">
                            <Label
                                for="note"
                                className="text-left">
                                บัญชีผู้ใช้งาน:
                            </Label>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">{getUsername}</p>
                        </FormGroup>
                    )}
                    {/* แสดงรหัสผ่าน */}
                    {item.password != null ? (
                        <FormGroup>
                            <Label>รหัสผ่าน:</Label>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">{item.password}</p>
                        </FormGroup>
                    ) : null}

                    <div className="border border-1">
                        <p className="text-center text-white" style={{ lineHeight: "3rem", backgroundColor: "#0A66C2" }}>เอกสารประกอบการสมัคร</p>
                        <div className="d-flex flex-column">
                            {item.fLocationPath != null ? (
                                <FormGroup className='d-flex justify-content-between px-5'>
                                    <Label>แผนที่ตั้งสถานที่ประกอบกิจการ</Label>
                                    <FaSistrix className="mx-3 style-icon" onClick={onClickUrl(`${item.fLocationPath}`)} />
                                </FormGroup>
                            ) : null}
                            {item.fCommercialPath != null ? (
                                <FormGroup className='d-flex justify-content-between px-5'>
                                    <Label>ใบทะเบียนพาณิชย์/ใบทะเบียนการค้าหรือเอกสารที่แสดงว่าประกอบธุรกิจ</Label>
                                    <FaSistrix className="mx-3 style-icon" onClick={onClickUrl(`${item.fCommercialPath}`)} />
                                </FormGroup>
                            ) : null}
                            {item.fCompanyPath != null ? (
                                <FormGroup className='d-flex justify-content-between px-5'>
                                    <Label>สำเนาหนังสือรับรองการจดทะเบียนนิติบุคคลพร้อมวัตถุประสงค์</Label>
                                    <FaSistrix className="mx-3 style-icon" onClick={onClickUrl(`${item.fCompanyPath}`)} />
                                </FormGroup>
                            ) : null}
                            {item.fAuthorisePath != null ? (
                                <FormGroup className='d-flex justify-content-between px-5'>
                                    <Label>หนังสือมอบอำนาจ</Label>
                                    <FaSistrix className="mx-3 style-icon" onClick={onClickUrl(`${item.fAuthorisePath}`)} />
                                </FormGroup>
                            ) : null}
                            {item.fVat20Path != null ? (
                                <FormGroup className='d-flex justify-content-between px-5'>
                                    <Label>สำเนาใบทะเบียนภาษีมูลค่าเพิ่ม (ภ.พ.20) </Label>
                                    <FaSistrix className="mx-3 style-icon" onClick={onClickUrl(`${item.fVat20Path}`)} />
                                </FormGroup>
                            ) : null}
                            {item.fFactoryPath != null ? (
                                <FormGroup className='d-flex justify-content-between px-5'>
                                    <Label>สำเนาใบอนุญาตประกอบกิจการโรงงาน (ร.ง.4)</Label>
                                    <FaSistrix className="mx-3 style-icon" onClick={onClickUrl(`${item.fFactoryPath}`)} />
                                </FormGroup>
                            ) : null}
                            {item.fOtherPath != null ? (
                                <FormGroup className='d-flex justify-content-between px-5'>
                                    <Label>เอกสารอื่นๆ</Label>
                                    <FaSistrix className="mx-3 style-icon" onClick={onClickUrl(`${item.fOtherPath}`)} />
                                </FormGroup>
                            ) : null}
                        </div>
                    </div>


                    {item.regisStatusName === "รอการอนุมัติ" ? (
                        <>
                            <Modal
                                isOpen={modal}
                                onRequestClose={modalToggle}
                                style={myCustomStyles}
                            // backdrop={"static"}
                            // keyboard={false}
                            >

                                <div className="d-flex justify-content-between align-items-center">
                                    <h3 className="w-100" style={{ color: "#0E527E", maxWidth: "720px", width: "100%" }}>กรุณากรอกหมายเหตุ</h3>
                                    <CgClose onClick={modalToggle} className="style-iconmodal" />
                                </div>
                                <hr />
                                <Form
                                    className="d-flex flex-column"
                                    autoComplete="off"
                                >
                                    <Input
                                        className="mb-3 w-100 customer-type border border-1 note-input"
                                        type="textarea"
                                        name="note"
                                        id="note"
                                        rows="4"
                                        cols="50"
                                        onChange={(e) => setMessage(e.target.value)}
                                    />
                                </Form>
                                <div className="d-flex justify-content-center align-items-center">
                                    <button
                                        type="button"
                                        className="btn-green px-2 w-25 mx-3"
                                        name="reject"
                                        id="reject"
                                        onClick={onSubmit}>
                                        ยืนยัน
                                    </button>
                                    <button
                                        type="button"
                                        className="btn-red px-2 w-25 mx-3"
                                        onClick={modalToggle}>
                                        ยกเลิก
                                    </button>
                                </div>
                            </Modal>


                            <div className="d-flex justify-content-center align-items-center mt-4">
                                <button
                                    type="button"
                                    className="btn-green mx-4 px-3"
                                    name="approve"
                                    id="approve"
                                    onClick={onSubmit}>
                                    อนุมัติการลงทะเบียน
                                </button>

                                <button
                                    type="button"
                                    className="btn-red mx-4 px-3"
                                    name="reject"
                                    id="reject"
                                    onClick={modalToggle}>
                                    ปฎิเสธการลงทะเบียน
                                </button>
                            </div>
                        </>


                    ) : null}

                </div>
            ))}

        </Container>
    );

}


